<template>
  <div class="content">
    <title-bar :title="$lang.bonus_title"></title-bar>
    <div class="t-c m-t-10">
      <img
        src="../../../assets/img/bonus/nine-bg.jpg"
        width="93%"
        style="border-radius: 13px"
      />
    </div>
    <div class="content-c">
      <div class="content-b">
        <div v-safe-html.rich="activityRuleHtml" class="content-gb"></div>
      </div>
      <div v-if="readError" class="read-error">{{ readError }}</div>
      <van-button
        @click="goToRec"
        size="large"
        class="custom-button m-t-20"
        :disabled="!csLinkResponse"
      >
        Telegram:{{ href || 'Unavailable' }}
      </van-button>
      <div v-if="csLinkError" class="read-error">{{ csLinkError }}</div>
      <div v-html="$lang.bonus_txt2" class="content-bg"></div>
    </div>
  </div>
</template>
<script>
import { GetCsLink, GetPromoRule } from '@/api/common'
import { openCustomerServiceUrl, resolveCustomerServiceUrl } from '@/views/layout/csLink'
import { customerServiceFailMessage, resolveCustomerServiceLink } from '@/views/layout/csLink'
import { isReadableOkResponse, responseFailMessage, safeArray, safeContent, safeObject, safeString } from '@/views/layout/safeLayout'

const ACTIVITY_RULE_LIST_KEYS = ['promoRuleList', 'ruleList', 'activityList', 'list', 'dataList', 'records', 'items']
const ACTIVITY_RULE_ENVELOPE_KEYS = ['content', 'payload', 'extra', 'page', 'data', 'body']
const ACTIVITY_RULE_FIELD_KEYS = ['promoRules', 'promo_rules', 'ruleContent', 'rule_content', 'rules', 'description', 'descr', 'content', 'detail', 'details', 'remark', 'remarks']
const ACTIVITY_RULE_READ_ERROR = '活动规则读取失败，已保留默认文案。'
const CS_LINK_READ_ERROR = '客服链接读取失败，当前入口暂不可用。'
const ACTIVITY_RULE_MAX_DEPTH = 12
const ACTIVITY_RULE_KEYS = ['cooperate', 'partner', 'telegram', '合作', '代理']

function collectActivityRules(source, depth = 0, out = [], seen = new Set()) {
  if (!source || typeof source !== 'object' || depth >= ACTIVITY_RULE_MAX_DEPTH || seen.has(source)) return out
  seen.add(source)
  for (const key of ACTIVITY_RULE_LIST_KEYS) {
    safeArray(source[key]).forEach(rule => out.push(rule))
  }
  for (const key of ACTIVITY_RULE_ENVELOPE_KEYS) {
    const value = source[key]
    if (!value || typeof value !== 'object') continue
    collectActivityRules(value, depth + 1, out, seen)
  }
  return out
}

function activityRuleText(rule) {
  const item = safeObject(rule)
  for (const key of ACTIVITY_RULE_FIELD_KEYS) {
    const value = safeString(item[key]).trim()
    if (value) return value
  }
  return ''
}

function matchesActivityRule(rule) {
  const item = safeObject(rule)
  const text = [
    item.activityType,
    item.activity_type,
    item.actTypeKey,
    item.act_type_key,
    item.promoType,
    item.promo_type,
    item.promoDetail,
    item.promo_detail,
    item.type,
    item.code,
    item.ruleCode,
    item.rule_code,
    item.name,
    item.title,
    item.descr,
    item.description
  ].map(safeString).join(' ').toLowerCase()
  return ACTIVITY_RULE_KEYS.some(key => text.includes(key))
}

export default {
  name: 'ActivityCooperate',
  components: {},
  data() {
    return {
      activityRuleHtml: this.$lang.bonus_txt,
      readError: '',
      href: '',
      csLinkResponse: null,
      csLinkError: ''
    }
  },
  mounted() {
    this.loadActivityRule()
    this.GetCsLink()
  },
  methods: {
    async loadActivityRule() {
      try {
        const data = await GetPromoRule()
        if (!isReadableOkResponse(data)) {
          this.readError = responseFailMessage(data, ACTIVITY_RULE_READ_ERROR)
          return
        }
        const rule = collectActivityRules(safeContent(data)).find(matchesActivityRule)
        const ruleHtml = activityRuleText(rule)
        if (ruleHtml) {
          this.activityRuleHtml = ruleHtml
          this.readError = ''
        }
      } catch (error) {
        this.readError = responseFailMessage(error, ACTIVITY_RULE_READ_ERROR)
      }
    },
    pickTelegramLink(response) {
      return resolveCustomerServiceUrl(response, 'telegram')
    },
    hasLoadedCsLink() {
      return !!(this.csLinkResponse || this.href)
    },
    setCsLinkReadFailure(message) {
      const fallback = message || CS_LINK_READ_ERROR
      this.csLinkError = this.hasLoadedCsLink()
        ? `${fallback}，已保留已加载客服入口。`
        : fallback
      if (!this.hasLoadedCsLink()) {
        this.csLinkResponse = null
        this.href = ''
      }
    },
    async GetCsLink() {
      try {
        const data = await GetCsLink()
        const link = resolveCustomerServiceLink(data, 'telegram')
        if (link.ok) {
          this.csLinkResponse = data
          this.href = link.url || this.pickTelegramLink(data) || this.href
          this.csLinkError = ''
        } else {
          this.setCsLinkReadFailure(link.message || CS_LINK_READ_ERROR)
        }
      } catch (e) {
        this.setCsLinkReadFailure(customerServiceFailMessage(e, CS_LINK_READ_ERROR))
      }
    },
    async goToRec() {
      if (!this.csLinkResponse) {
        if (this.$toast) {
          this.$toast({
            message: this.csLinkError || CS_LINK_READ_ERROR,
            icon: 'cross'
          })
        }
        return
      }
      const opened = openCustomerServiceUrl(this.csLinkResponse, 'telegram')
      if (!opened) {
        this.csLinkError = customerServiceFailMessage(this.csLinkResponse, this.csLinkError || CS_LINK_READ_ERROR)
        if (this.$toast) {
          this.$toast({
            message: this.csLinkError,
            icon: 'cross'
          })
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.content-c {
  padding: 1% 3% 3%;
}

.content-gb {
  margin-top: 10px;
  border-radius: 8px;
  padding: 15px 10px;
  background: @cont-bg;
  line-height: 20px;
}
.content-bg {
  padding: 2%;
  margin-top: 10px;
  line-height: 20px;
}
.read-error {
  padding: 0 2%;
  margin-top: 8px;
  color: #f56c6c;
  font-size: var(--vk-fs-xs);
  line-height: 16px;
}
</style>
